
import { StdResponse, request } from "@/global/config/request";
import { Project } from "@/global/interface/project-manage/project";

export function initProject(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectUuid}/init`, null, {
        params: {
            ...params,
        }
    })
}

export function getProjects(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects`, {
        params: {
            ...params,
        }
    })
}
export function getProjectDetail(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}`, {
        params: {
            ...params,
        }
    })
}

export function createProject(data: Project, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects`, data, {
        params: {
            ...params,
        }
    })
}